import { Row, Col, ListGroup } from "react-bootstrap";
import { useNavigate } from "react-router";
import { useTranslation } from "../../hooks/useLocalization";

const NavbarTutorialItem = ({
  icon,
  title,
  complSteps,
  totalSteps,
  time,
  spacing,
  href,
  mark,
  onClick,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const style = {
    cursor: "pointer",
  };
  return (
    <ListGroup.Item
      onClick={(event) => {
        if (typeof onClick === "function") {
          onClick(event);
          if (event.defaultPrevented) return;
        }
        href && navigate(href);
        document.dispatchEvent(new MouseEvent("click"));
      }}
      style={style}
    >
      <Row className="align-items-center g-0">
        {mark && (
          <span className="text-primary w-0 position-absolute end-0 me-3">
            ●
          </span>
        )}
        <Col xs={2}>{icon}</Col>
        <Col xs={10} className={spacing ? "pl-2" : null}>
          <div className="text-dark">{t(title)}</div>
          <div className="text-muted small mt-1">{t("Steps") + ": " + complSteps + "/" + totalSteps}</div>
          <div className="text-muted small mt-1">{time}</div>
        </Col>
      </Row>
    </ListGroup.Item>
  );
};

export default NavbarTutorialItem;